var gm = (function(gm) {
	function parseNumberList(str) { return str!=null && str.toString().match(/-?[0-9.]+/g) || null }  // returns null or [lat, lng]
	gm.parseNumberList = parseNumberList;
	function pairBuilder(className, fields) { return (fields && fields.map) ? function(pair){ if(pair&&pair.constructor==google.maps[className]) return pair; return (pair = parseNumberList(pair) || pair && fields && fields.map && parseNumberList(fields.map(function(field) { return pair[field] }) || null )) && pair.length==2 && new google.maps[className](+pair[0], +pair[1]) || null; } : function(pair){ if(pair&&pair.constructor==google.maps[className]) return pair; return (pair = parseNumberList(pair)) && pair.length==2 && new google.maps[className](+pair[0], +pair[1]) || null; };}
	gm.LatLng = pairBuilder('LatLng', ['lat', 'lng']);
	gm.Size = pairBuilder('Size');
	gm.Point = pairBuilder('Point');
	gm.Bounds = Bounds;
	gm.Marker = Marker;
	gm.markerOptions = markerOptions;
	gm.iconOptions = iconOptions;
	gm.instances = gm.instances || {};
	gm.ready = function ready () { return !!(window.google && google.maps && google.maps.Map) };
	gm.init = function init() {
		if(document.readyState == 'loading')
			return setTimeout('gm.init()');
		for(var p in gm.instances)
			if(gm.instances[p].postponed && typeof gm.instances[p].init == 'function') gm.instances[p].init();
	};
	var loading;
	gm.loadAsync = function loadAsync() {
		if(gm.ready() || loading) return;
		loading = true;
		jQuery.getScript(googleMapsUrl + "&callback=gm.init");
	};

	gm.geoDistance = geoDistance;
	gm.meterPerPixel = meterPerPixel;
	gm.maxZoomForBounds = maxZoomForBounds;
	var R = 6371.64;
	return gm;

	function Bounds(b) {
		var args = Array.prototype.slice.call(arguments), ret;
		if(b&&b.constructor==google.maps.LatLngBounds) {
			ret = true; args.shift();
		}
		else {
			if(b===true || b === false)
				ret = args.shift(); 
			b = new google.maps.LatLngBounds;
		}
		var data = gm.parseNumberList(args) ||[];
		if(0==(data.length&1) && data.length) {
			if(data.length) ret = true;
			while(data.length)
				b.extend(gm.LatLng(data.splice(0, 2)));
		}
		return ret ? b : null;
	};

	function iconOptions(options) {
		var p;
		if((typeof options == 'string' || typeof options == 'number') && gm.icons[options])
			options = gm.icons[options];
		if(typeof options == 'string')
			options = { url: options };
		else if(options!=null && options.url) {
			for(p in options) {
				if(options[p]) {
					if(/size/i.test(p))
						options[p] = gm.Size(options[p]);
					else if(/origin|anchor/.test(p))
						options[p] = gm.Point(options[p]);
				}
			}
		}
		return options;
	}

	function markerOptions(options) {
		var p, p;
		if(options.constructor==Array) options = { position: options };
		for(p in options) {
			if(p=='icon'||p=='shadow')
				options[p] = iconOptions(options[p]);
			else if(/position|location/i.test(p))
				options.position = gm.LatLng(options[p]);
		}
		return options;
	}
	
	function Marker(markerOptions) {
		return new google.maps.Marker(gm.markerOptions(markerOptions));
	}

	function geoDistance(latlng1, latlng2) { // km
		latlng1 = gm.LatLng(latlng1); latlng2 = gm.LatLng(latlng2);
		if(!latlng1 || !latlng2) return NaN;
		var a = Math.pow(Math.sin((latlng2.lat()-latlng1.lat())*Math.PI/360), 2) + Math.pow(Math.sin((latlng2.lng()-latlng1.lng())*Math.PI/360), 2) * Math.cos(latlng1.lat()*Math.PI/180) * Math.cos(latlng2.lat()*Math.PI/180);
		return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
	}
	function meterPerPixel (latitude, zoom) {
		return 1000 * R * 2*Math.PI / 256 * Math.cos(latitude * Math.PI / 180) / (1 << zoom)
	}
	function maxZoomForBounds(bounds, width, height) {
		var b = bounds.toJSON(), cosLat = Math.cos((b.north+b.south)/2*Math.PI/180);
		return -Math.max(Math.log((b.east-b.west)/width*256/360), Math.log((b.north-b.south)/height*256/360 / cosLat))/Math.log(2);
	}
})(window.gm || {});
